export function PaneLoading({ label }: { label: string }) {
  return (
    <div className="flex h-full items-center justify-center gap-2.5 text-sm text-muted">
      <span className="h-4 w-4 animate-spin rounded-full border-2 border-line-strong border-t-accent" />
      <span>{label}</span>
    </div>
  );
}
